"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.pagination = exports.navigation = exports.SPACING = exports.SLIDE_WIDTH = exports.SLIDE_HEIGHT = void 0;
const SPACING = exports.SPACING = 16;
const SLIDE_WIDTH = exports.SLIDE_WIDTH = 52;
const SLIDE_HEIGHT = exports.SLIDE_HEIGHT = 52;
const pagination = exports.pagination = {
  show: false
};
const navigation = exports.navigation = {
  showArrows: false
};
